var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 83,
    viewBox: "0 0 84 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8691 74.6144C25.8691 79.0627 29.4891 82.6826 33.9374 82.6826C38.3857 82.6826 42.0056 79.0627 42.0056 74.6144C42.0056 70.1661 38.3857 66.5461 33.9374 66.5461C29.4891 66.5461 25.8691 70.1661 25.8691 74.6144ZM33.9374 71.925C35.4192 71.925 36.6268 73.1325 36.6268 74.6144C36.6268 76.0962 35.4192 77.3038 33.9374 77.3038C32.4555 77.3038 31.248 76.0962 31.248 74.6144C31.248 73.1325 32.4555 71.925 33.9374 71.925Z",
    fill: "currentColor",
    stroke: "none",
    strokeWidth: 71.7177
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8184 74.6144C60.8184 79.0627 64.4383 82.6826 68.8866 82.6826C73.3349 82.6826 76.9548 79.0627 76.9548 74.6144C76.9548 70.1661 73.3349 66.5461 68.8866 66.5461C64.4383 66.5461 60.8184 70.1661 60.8184 74.6144ZM68.8866 71.925C70.3685 71.925 71.576 73.1325 71.576 74.6144C71.576 76.0962 70.3685 77.3038 68.8866 77.3038C67.4047 77.3038 66.1972 76.0962 66.1972 74.6144C66.1972 73.1325 67.4047 71.925 68.8866 71.925Z",
    fill: "currentColor",
    stroke: "none",
    strokeWidth: 71.7177
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6512 61.1671H28.5523C27.0705 61.1671 25.8629 59.9595 25.8629 58.4777V55.7883H66.2041C70.3996 55.7883 74.4794 52.6013 75.496 48.5322L82.2599 21.4767C82.4616 20.6726 82.2787 19.8227 81.7704 19.1692C81.2621 18.5157 80.4795 18.1365 79.6512 18.1365H18.1604L16.2079 9.35554C15.2908 5.22998 11.8538 2 8.38174 2H4.34762C2.86306 2 1.6582 3.20486 1.6582 4.68941C1.6582 6.17397 2.86306 7.37883 4.34762 7.37883H8.38174C9.04333 7.37883 10.5252 8.57293 10.9582 10.5228L13.3276 21.189C13.3491 21.3423 13.3814 21.4875 13.4271 21.6327L20.4841 53.392V58.4777C20.4841 62.926 24.104 66.5459 28.5523 66.5459H33.9312H68.8935H79.6512C81.1357 66.5459 82.3406 65.3411 82.3406 63.8565C82.3406 62.3719 81.1357 61.1671 79.6512 61.1671V61.1671ZM76.206 23.5153L70.2759 47.2279C69.8617 48.8926 67.92 50.4094 66.2041 50.4094H25.3304L19.3545 23.5153H76.206Z",
    fill: "currentColor",
    stroke: "none",
    strokeWidth: 2.88148
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.448438cdcb498cadf37027fc326a257a.svg";
export { ForwardRef as ReactComponent };